<template>
    <div id="regi">
        <div id="admin_wrap" v-bind:style="{backgroundImage: 'url(' + store_bg_image + ')', backgroundSize: '100%'} ">
            <div class="admin-text">
                <span v-bind:style="{color:'#FFF'}">관리자 로그인</span>
            </div>
            <div class="admin-body">
                <input type="text" v-model="admin_id" name="admin_id" ref='admin_id' v-on:focus='inputFocus("admin_id")' placeholder="아이디" autocomplete="off" class="keyboardInput" id="keyboardInputInitiator1">
                <input type="password" v-model="admin_password" name="admin_password" ref='admin_password' v-on:focus='inputFocus("admin_password")' placeholder="비밀번호" autocomplete="off" class="keyboardInput" id="keyboardInputInitiator2">
            </div>
        </div>
        <div class="admin-footer">
            <input type="button" class="admin-cancel" @click="close" value="취소">
            <input type="button" class="admin-login" @click="login" value="로그인">
        </div>
        <virtual-keyboard3 v-if="current_focus.type=='KEYBOARD1'" v-bind:parent_key_str="admin_id" v-on:keyClick="keyInput1"></virtual-keyboard3>
        <virtual-keyboard2 v-if="current_focus.type=='KEYBOARD2'" v-bind:parent_key_str="admin_password" v-on:keyClick="keyInput2"></virtual-keyboard2>
    </div>
</template>

<script>
const FOCUS_TYPE = {
    ADMIN_ID: {name:'admin_id', type: 'KEYBOARD1'},
    ADMIN_PASSWORD: {name:'admin_password', type: 'KEYBOARD2'},
}
// import keyboard from "../../javascript/web_keyboard2";

import common from '@/javascript/common.js'
import virtualKeyboard3 from '../components/vk-eng';
import virtualKeyboard2 from '../components/vk-eng2';
import numPad from '../components/num-pad';

// 사용자 정의 모듈.
import * as config from '../../javascript/config';

import vue from 'vue';
vue.component('virtual-keyboard3', virtualKeyboard3);
vue.component('virtual-keyboard2', virtualKeyboard2);
vue.component('num-pad', numPad);

export default {
    data: function () {
        return {
            del_password: '',
            step: 0,
            admin_id: '',
            admin_password: '',
            current_focus: FOCUS_TYPE.ADMIN_ID,
            parent_key_str: '',
            store_bg_image:'',
        }
    },
    methods: {
        keyInput1(keyStr) {
            this.admin_id = keyStr;
        },
        keyInput2(keyStr) {
            this.admin_password = keyStr;
        },
        inputFocus(type) {
            const focusObjectList = Object.values(FOCUS_TYPE);
            focusObjectList.forEach(
                (element) => {
                    if( element.name==type ) this.current_focus = element;
            });

            this.parent_key_str = this.current_focus.name;
        },
        close() {
            this.$emit('close');
            this.$router.push('/start');
        },
        login() {
            var agree_p = 0;
            var store_id = this.$store.getters['getStoreId'];
            if (this.admin_id.length == 0) {
                const alert_param = {
                code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                message: `아이디를 입력해주세요.`,
                router: '',
                };
                this.$store.commit('set_popup_type', alert_param);
                return;
            }
            if(this.admin_password.length == 0){
                const alert_param = {
                code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                message: `비밀번호를 입력해주세요.`,
                router: '',
                };
                this.$store.commit('set_popup_type', alert_param);
                return;
            }

            var self = this;
            const type = config.REQ_ADMIN_LOGIN;
            const data = {
                data: {
                    'id': this.admin_id,
                    'password': this.admin_password
                }

            }; // store_id는 공통으로 추가하니까 생략. 예) {user_id: 123}
            this.$store.dispatch(type.action_name, {
                type: type,
                data: data
            }).then(function (response) {
                if(response.result){
                    self.$router.push('payment_cancel');
                }else{
                    const alert_param = {
                        code: self.$store.getters['get_popup_code'].POPUP_ALERT,
                        message: `아이디와 패스워드를 확인하세요.`,
                        router: '',
                    };
                    self.$store.commit('set_popup_type', alert_param);
                }
            }).catch(function (error) {
                console.log('error=============>', error);
            });

        }

    },
    mounted() {

        this.$refs.admin_id.focus();

        this.$nextTick(function () {
            //common.con_test('func_test');

        });

        this.store_bg_image = this.$store.getters['get_store_bg_img_url'];

    },

}
</script>



// WEBPACK FOOTER //
// src/components/page/admin_login.vue